// extracted by mini-css-extract-plugin
export var chip = "_5c-9";
export var chipLabel = "_5c-a";
export var close = "_5c-7";
export var closeIcon = "_5c-8";
export var error = "_5c-6";
export var infoTooltip = "_5c-2";
export var innerContainer = "_5c-1";
export var input = "_5c-b";
export var medium = "_5c-5";
export var outerContainer = "_5c-0";
export var small = "_5c-4";
export var xSmall = "_5c-3";